import * as React from 'react';
import StringFormatter from '../../Helpers/StringFormatter';
require('../../css/amount-selection.css');

interface Props {
    donationAmount: number;
    message?: string;
    thankYouTextColor?: string;
    priceSymbol?: string;
    paymentSelection?: string;
}

class ThankYouMessage extends React.Component<Props> {

    render() {
        let thankYouTextColorClass = '';
        if (this.props.thankYouTextColor) {
            thankYouTextColorClass = this.props.thankYouTextColor;
        }
        let overAllDivClass = 'thankyou-message blueBackGround';

        if (this.props.message) {
            return (
                  <div className={overAllDivClass}>
                    <h1 className={thankYouTextColorClass}>Thank you for your donation of{' '}
                      {this.props.priceSymbol}{StringFormatter.numberAsCurrency(this.props.donationAmount)}{this.props.paymentSelection === 'monthly' ? '/month' : ''}
                    </h1>
                    <p>
                      <div dangerouslySetInnerHTML={{ __html: this.props.message }} />
                    </p>                    
                   
            </div>                                   
              );
              
        }

        return (
            <div className="thankyou-message">
                <h1 className={thankYouTextColorClass}>Thank you for your donation of{' '} 
                {this.props.priceSymbol}{StringFormatter.numberAsCurrency(this.props.donationAmount)}{this.props.paymentSelection === 'monthly' ? '/month' : ''}</h1>
                <p className={thankYouTextColorClass}>
                    Thank you for your contribution to the Butterfly
                    Conservation Society. Your support is greatly
                    appreciated.
                </p>
            </div>
        );
    }
}

export default ThankYouMessage;


// WEBPACK FOOTER //
// ./src/MakeDonation/SignupJourney/ThankYouMessage.tsx